import { Action, createReducer, on } from "@ngrx/store";
import {ReactionsActions} from "./reactionsActions";
import {friendReactionCountsAdapter, initialReactionsState, reactionCountsAdapter} from "./reactions.state";

export const reactionsReducer = createReducer(
    initialReactionsState,
    on(ReactionsActions.foundFriendReactions, (state, { friendReactions }) => {
        return {
            ...state,
            friendReactionCounts: friendReactionCountsAdapter.addMany(friendReactions, state.friendReactionCounts)
        }
    }),
    on(ReactionsActions.foundReactionCounts, (state, { reactionCounts }) => {
        return {
            ...state,
            reactionCounts: reactionCountsAdapter.addMany(reactionCounts, state.reactionCounts)
        }
    }),
    on(ReactionsActions.foundFriendReaction, (state, { friendReaction }) => {
        return {
            ...state,
            friendReactionCounts: friendReactionCountsAdapter.addOne(friendReaction, state.friendReactionCounts)
        }
    }),
    on(ReactionsActions.foundReactionCount, (state, { reactionCount }) => {
        return {
            ...state,
            reactionCounts: reactionCountsAdapter.addOne(reactionCount, state.reactionCounts)
        }
    }),
);
